export default "__VITE_ASSET__CQUAoBpS__"